<template>
  <div class="order_detail">
    <nav-bar/>
    <search-bar/>
    <div class="main" v-if="loading">
      <div class="p20 bg_white mb20">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/me/myservice' }" v-if="!$route.query.id">服务订单</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/me/myorder' }" v-else>我的订单</el-breadcrumb-item>
          <el-breadcrumb-item>发布订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p20 bg_white">
        <el-form label-width="100px" :rules="rules" :model="submit_form" class="">
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="服务地址:" prop="address">
                <el-select v-model="submit_form.address_id" placeholder="请选择">
                  <el-option
                      v-for="item in address_list"
                      :key="item.address_id"
                      :label="item.address"
                      :value="item.address_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="服务类型:" prop="type">
                <el-select
                    v-model="submit_form.type_id"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in Service_types_list"
                      :key="item.type_id"
                      :label="item.type_name"
                      :value="item.type_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="服务人员:" prop="member">
                <el-select
                    v-model="submit_form.level_id"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in Service_levels_list"
                      :key="item.level_id"
                      :label="item.level_name"
                      :value="item.level_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="服务时间:" prop="time">
                <el-date-picker
                    v-model="submit_form.service_time"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="发票信息:">
                <el-select
                    v-model="invoice_id"
                    clearable
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in invoice_list"
                      :key="item.invoice_id"
                      :label="item.invoice_name"
                      :value="item.invoice_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="备注信息">
                <el-input type="textarea" v-model="order_remark" resize="none" :rows="6"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item label="备注图片">
                <img-upload :file_list.sync="order_imgs"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item>
                <span v-show="!is_Empty(price)">预估价格:<span class="ml10">¥{{ price }}</span></span>
                <span v-show="!is_Empty(km)" class="ml20">距离:<span class="blue ml10">{{
                    km
                  }}KM</span></span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="10" :md="12" :sm="24" :xs="24">
              <el-form-item>
                <el-button size="small" type="primary" @click="paramsInit">申请服务</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>
      <div class="info_box" v-if="false">
        <!-- 服务类型 -->
        <div class="order_cell fr ac mb20">
          <p class="fz14 order_cell_title mr10 need">服务类型:</p>
          <div class="fr ac fw">
            <p
                v-for="i in Service_types_list"
                :key="i.type_id"
                class="unselected cursor"
                :class="{active:type_id == i.type_id}"
                @click="type_id = i.type_id"
            >{{ i.type_name }}</p>
          </div>
        </div>
        <!-- 服务工程师-->
        <div class="order_cell fr ac mb20">
          <p class="fz14 order_cell_title mr10 need">服务工程师:</p>
          <div class="fr ac fw">
            <p
                v-for="i in Service_levels_list"
                :key="i.level_id"
                class="unselected cursor"
                :class="{active:level_id == i.level_id}"
                @click="level_id = i.level_id"
            >{{ i.level_name }}</p>
          </div>
        </div>
        <!-- 距离-->
        <div class="order_cell fr ac mb20">
          <p class="fz14 order_cell_title mr10 need">距离:</p>
          <div class="fr ac fw">{{ km }}km</div>
        </div>
        <!-- 价格-->
        <div class="order_cell fr ac mb20">
          <p class="fz14 order_cell_title mr10 need">价格:</p>
          <div class="fr ac fw red">￥{{ price }}</div>
        </div>
        <el-divider/>
        <div class="order_cell fr mb20">
          <p class="fz14 order_cell_title">其他需求:</p>
          <div class="ml20 textre">
            <el-input
                type="textarea"
                resize="none"
                :rows="4"
                v-model="order_remark"
                placeholder="请输入其他需求"
            ></el-input>
          </div>
        </div>
        <div class="order_cell fr afs mb20">
          <p class="fz14 order_cell_title">图片描述:</p>
          <div class="fr fw">
            <up-load :file_list.sync="order_imgs" :limit="6"/>
          </div>
        </div>
        <el-divider/>
        <div class="fr ac jc">
          <el-button type="primary" class="mt20 mb20" @click="submit(1)">申请服务</el-button>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";

export default {
  data() {
    return {
      rules: {
        name: [
          {required: true, message: '请选择客户', trigger: 'blur'},
        ],
        address: [
          {required: true, message: '请选择服务地址', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择服务类型', trigger: 'blur'},
        ],
        member: [
          {required: true, message: '请选择服务人员', trigger: 'blur'},
        ],
        time: [
          {required: true, message: '请选择服务时间', trigger: 'blur'},
        ],
      },
      submit_form: {
        name: "",
        address_id: "",
        type_id: "",
        level_id: "",
        service_time: []
      },
      order_imgs: [],
      loading: true,
      Service_types_list: [],
      Service_levels_list: [],
      address_list: [],
      invoice_list: [],
      type_id: null,
      level_id: null,
      invoice_id: null,
      order_remark: "",
      price: "",
      km: "",
      is_summit: "0",
    };
  },
  created() {
    this.getServiceTypes();
    this.getServiceLevels();
    this.getMemberAddress();
    this.getInvoices();
    // this.submit();
  },
  watch: {
    'submit_form.type_id'(n) {
      this.paramsInit();
    },
    'submit_form.level_id'(n) {
      this.paramsInit();
    },
    'submit_form.address_id'(n) {
      this.paramsInit();
    }
  },
  methods: {
    //获取客户地址列表
    getMemberAddress() {
      this.post("addressInterfaces/v1.0/getMemberAddress", {
        page: -1,
        page_size: -1
      }).then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.address = [];
          el.address.push(el.address_province);
          el.address.push(el.address_city)
          el.address.push(el.address_country)
          el.address = el.address.join("/")
          el.address += `    ${el.address_detailed}`
        })
        this.address_list = arr;
      })
    },

    //获取客户发票列表
    getInvoices(company_id) {
      this.post("invoiceInterfaces/v1.0/getInvoices", {
        company_id,
        page: -1,
        page_size: -1
      }).then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.invoice_name = `${el.invoice_type == '1' ? "增值税普票" : "增值票专票"} ${el.invoice_name}`
        })
        this.invoice_list = arr;
      })
    },
    paramsInit(type) {
      let obj = {
        level_id: this.submit_form.level_id,
        type_id: this.submit_form.type_id,
        address_id: this.submit_form.address_id,
        invoice_id: this.invoice_id,
        order_remark: this.order_remark,
        order_imgs: this.arrToStr(this.order_imgs),
      };
      if (this.is_Empty(obj.type_id) || this.is_Empty(obj.level_id) || this.is_Empty(obj.address_id)) {
        return;
      }

      let item = {};
      this.address_list.some(el => {
        if (el.address_id == this.submit_form.address_id) {
          item = el;
        }
      })
      obj.company_province = item.address_province
      obj.company_city = item.address_city
      obj.company_country = item.address_country
      obj.company_address = item.address_detailed;
      obj.service_start_time = this.submit_form.service_time[0] || "";
      obj.service_end_time = this.submit_form.service_time[1] || "";
      if (this.is_Empty(type)) {
        this.checkout(obj);
      } else {
        this.submit(obj);
      }
    },
    checkout(obj) {

      this.post("serviceInterfaces/v1.0/checkout", obj).then((res) => {
        this.km = res.data.order_distance;
        this.price = res.data.order_actual_price;
      });
    },
    // 提交订单
    submit(obj) {
      if (this.$route.query.id) {
        obj.goods_order_id = this.$route.query.id;
      }
      this.post("serviceInterfaces/v1.0/insertServiceOrder", obj).then(
          (res) => {
            this.$message({
              message: "服务已申请,请等待审核",
              type: "success",
            });
            this.back();
          }
      );
    },
    // 服务类型.
    getServiceTypes() {
      this.post("serviceInterfaces/v1.0/getServiceTypes").then((res) => {
        this.Service_types_list = res.data;
      });
    },
    // 服务人员登记
    getServiceLevels() {
      this.post("serviceInterfaces/v1.0/getServiceLevels").then((res) => {
        this.Service_levels_list = res.data;
      });
    },
  },
  components: {NavBar, SearchBar, FooterBar, "up-load": Upload},
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .el-select, .el-date-editor, .el-autocomplete {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/serviceOrder/releaseservice.vue